import React, { useState } from "react";

import MuiSelect from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";

import {
  useOnEscEffect,
  useOnReFocuse,
  useOnShiftEnterEffect,
  useOnShiftTabEffect,
  useOnTabEffect,
} from "../../../utils/keyEffects";

export default function SelectField({
  field,
  onSubmit,
  setValue,
  value,
  innerRef,
  onRevert,
  setEdit,
  rowIndex,
  columnIndex,
  nextRow,
  prevRow,
  nextColumn,
  prevColumn,
  onClose,
  onChange,
  options,
  displayNone = true,
  ...props
}) {
  const [open, setOpen] = useState(true);

  const handleClose = () => {
    setOpen(false);
    onRevert();
    onClose();
  };

  const onSubmitPrevRow = () => {
    setOpen(false);
    onSubmit();
    prevRow();
  };

  const onSubmitNextCol = () => {
    setOpen(false);
    onSubmit();
    nextColumn();
  };

  const onSubmitPrevCol = () => {
    setOpen(false);
    onSubmit();
    prevColumn();
  };

  const handleSubmit = value => {
    setOpen(false);
    onSubmit(value);
    nextRow();
  };

  useOnShiftEnterEffect(innerRef, onSubmitPrevRow);
  useOnTabEffect(innerRef, onSubmitNextCol);
  useOnShiftTabEffect(innerRef, onSubmitPrevCol);
  useOnReFocuse(innerRef, handleClose);
  useOnEscEffect(innerRef, handleClose);

  return (
    <FormControl fullWidth variant="outlined" size="small">
      <MuiSelect
        open={open}
        onClick={() => setOpen(true)}
        ref={innerRef}
        data-id={field.id}
        labelId={field.id}
        id={field.id}
        value={value}
        {...props}
        displayEmpty
        onClose={handleClose}
        onChange={event => handleSubmit(event.target.value)}
        sx={{
          "& .MuiSelect-select": {
            width: "100%",
          },
        }}
      >
        {props.displayNone && (
          <MenuItem data-parent-id={field.id} data-id={`${field.id}-none-item`} value="">
            <em>None</em>
          </MenuItem>
        )}

        {options.map(([optionValue, label]) => (
          <MenuItem
            key={optionValue}
            value={optionValue}
            data-parent-id={field.id}
            data-select-id={field.id}
            data-id={`${field.id}-${optionValue}-item`}
          >
            {label}
          </MenuItem>
        ))}
      </MuiSelect>
    </FormControl>
  );
}
